import React from 'react'
import PropTypes from 'prop-types'

import {
  MESSAGE_TYPE_ERROR,
  MESSAGE_TYPE_LOG,
  MESSAGE_TYPE_SUCCESS,
} from '../constants/messages.constatns.js'

import '../styles/messages.less'

export default function MessageDisplay ({ messages, onMessageRead }) {
  return (
    <div className='message_display'>
      {messages.map((m, idx) => (
        <div
          key={m.id}
          className={['card', 'message', messageTypeCss[m.messageType]].join(' ')}
          onClick={() => onMessageRead(m.id)}
        >{m.text}</div>
      ))}
    </div>
  )
}

MessageDisplay.propTypes = {
  message: PropTypes.arrayOf(
    PropTypes.shape({
      messageType: PropTypes.string,
      text: PropTypes.string,
      id: PropTypes.number,
    })
  ),
  onMessageRead: PropTypes.func
}

const messageTypeCss = {
  [MESSAGE_TYPE_ERROR]: 'message--error',
  [MESSAGE_TYPE_LOG]: 'message--log',
  [MESSAGE_TYPE_SUCCESS]: 'message--success'
}
